import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';
import { useMemo } from 'react';
import Menu from 'antd/lib/menu';

import { useAddNewRepositoryButton } from './hooks';

export const AddNewRepositoryButton = () => {
  const { providers, isLoading, onClick } = useAddNewRepositoryButton();

  const menu = useMemo(
    () => (
      <Menu
        items={providers.map((provider) => ({
          key: provider.provider,
          label: provider.provider,
          disabled: !provider.isAvailable,
          onClick: () => onClick(provider),
        }))}
      ></Menu>
    ),
    [providers],
  );

  return (
    <Dropdown overlay={menu} placement="bottomLeft">
      <Button loading={isLoading}>Add a new repository</Button>
    </Dropdown>
  );
};
